import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import {
  Radio, Form, Rate, Button, Pagination,
} from 'antd';
import RichTextArea from '../../../coms/rich/RichTextArea';
import CommentReplyBox from './CommentReplyBox';
import util from '../../../util/index';
const { isWeaver } = util;
const isweaver = isWeaver();
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const store = ['modeListStore', 'appDetailStore'];
@inject(...store)
@observer
class App extends React.Component {

  getSubdata = (db, dbsreply) => {
    return dbsreply.filter(el => (db.ds_id === el.ds_fid));
  }

  onChangePage = (page) => {
    const { modeListStore: { appDetail }, appDetailStore: { getDeb } } = this.props;
    getDeb({ current: page, sw_id: toJS(appDetail).app.sw_id, s_number: toJS(appDetail).app.s_number });
  }
  onSubmit = () => {
    const { modeListStore: { appDetail }, appDetailStore: { addDeb }, form } = this.props;
    addDeb({ sw_id: toJS(appDetail).app.sw_id, s_number: toJS(appDetail).app.s_number, ...form.getFieldsValue() }).then(() => {
      form.resetFields();
      this.DsContent && this.DsContent.clear();
    });
  }
  render() {
    const { prefixCls, form, appDetailStore: { addLoading, dbsCount, current, pageSize } } = this.props;
    let { appDetailStore: { dbs, dbsReply } } = this.props;
    dbs = toJS(dbs);
    dbsReply = toJS(dbsReply);
    const { getFieldProps, getFieldValue } = form;
    return (
      <div className={prefixCls}>
        {
          isweaver && [
            <RadioGroup {...getFieldProps("ds_type", { initialValue: "0" })} key="ds_type">
              <RadioButton value="0">普通</RadioButton>
              <RadioButton value="1">咨询</RadioButton>
              <RadioButton value="2">需求</RadioButton>
              <RadioButton value="3">问题</RadioButton>
            </RadioGroup>,
            <Rate {...getFieldProps("ds_score", { initialValue: 5 })} key="ds_score" />,
            <div className={`${prefixCls}-btn`} key="ds_btn">
              <Button loading={addLoading} type="primary" onClick={this.onSubmit} disabled={!getFieldValue('ds_content')}>提交</Button>
            </div>,
            <div className={`${prefixCls}-richtext`} key="ds_richtext">
              <RichTextArea
                {...getFieldProps("ds_content", { initialValue: '' })}
                ref={el => this.DsContent = el}
                pluginOptions={{
                  toolbar: [
                    ['Bold', 'Italic', 'Underline', 'Strike'],
                    ['Cut', 'Copy', 'Paste'],
                    ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', 'Blockquote'],
                    ['Image'],
                    ['Table'],
                    ['tools'],
                    ['Styles', 'Format', 'Font', 'FontSize'],
                    ['TextColor', 'BGColor']
                  ],
                  height: "100px"
                }} />
            </div>,
          ]
        }
        {
          dbs && dbs.length > 0 && (
            <div className={`${prefixCls}-dbs`}>
              {
                dbs.map(db => (
                  <CommentReplyBox
                    {...this.props}
                    prefixCls={`${prefixCls}-replyBox`}
                    key={db.ds_id}
                    data={db}
                    subdata={this.getSubdata(db, dbsReply)}
                    />
                ))
              }
            </div>
          )
        }
        {
          parseInt(dbsCount, 10) > 0 && (
            <Pagination size="small" current={current} total={parseInt(dbsCount, 10)} pageSize={pageSize} onChange={this.onChangePage} showTotal={total => (<span>共{total}条</span>)} />
          )
        }
      </div>
    )
  }
}

App = Form.create()(App);
export default App;


// WEBPACK FOOTER //
// ./src/components/mode/appDetail/Comment.js